import { Loader2 } from "lucide-react";
import { cn } from "@/utils/stylesUtils";

function ActionButton({
  onClick,
  disabled,
  loading,
  loadingLabel,
  label,
  variant = "neutral",
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex-1 flex items-center justify-center gap-1.5",
        "px-3 py-2 rounded text-[16px] font-bold transition",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variant === "primary"
          ? "bg-[#3386D912] border border-[#3286DA] text-[#1a5fa8] hover:bg-[#3386D924]"
          : "bg-white border border-[#DDDDDD] hover:bg-gray-100 text-gray-700",
      )}
    >
      {loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
      {loading ? loadingLabel : label}
    </button>
  );
}

export default function AccessControlActions({
  isAdmin,
  restriction,
  isLockedByDistrict,
  isRevoking,
  onEdit,
  onRevoke,
  onCreateSchoolRule,
}) {
  if (isAdmin && isLockedByDistrict && !restriction) {
    return (
      <ActionButton
        onClick={onCreateSchoolRule}
        label="Add School Pause"
        variant="primary"
      />
    );
  }

  if (isAdmin && isLockedByDistrict && restriction) {
    return (
      <div className="flex flex-col gap-2 sm:flex-row">
        <ActionButton
          onClick={onEdit}
          disabled={isRevoking}
          label="Edit Dates/Times"
          variant="primary"
        />
        <ActionButton
          onClick={onRevoke}
          disabled={isRevoking}
          loading={isRevoking}
          loadingLabel="Turning on…"
          label="Turn App Back ON"
        />
      </div>
    );
  }

  if (!restriction) return null;

  return (
    <div className="flex flex-col gap-2 sm:flex-row">
      <ActionButton
        onClick={onEdit}
        disabled={isRevoking}
        label="Edit Details"
        variant="primary"
      />
      <ActionButton
        onClick={onRevoke}
        disabled={isRevoking}
        loading={isRevoking}
        loadingLabel="Ending pause…"
        label="Turn App Back ON"
      />
    </div>
  );
}
